import AppSettings from '../AppSettings';
// Librairies
import Axios from 'axios';
import Cookies from 'universal-cookie';
// Services
import { showToast } from '../utils/ToastsUtil';
import i18n from '../locales/i18n';

const BACKEND_ENDPOINT = AppSettings.getBackendUrl();

export default class SubscriptionsService {
    static getSubscriptionTemplates() {
        return Axios.get(BACKEND_ENDPOINT + 'admin/subscriptions/templates', {
            headers: { 'Authorization': `Bearer ${new Cookies().get('token')}` }
        }).then(response => {
            return response.data;
        }, () => {
            showToast('subscription_templates_loading_failed');
            return;
        });
    }

    static addTemplate(template) {
        return Axios.post(BACKEND_ENDPOINT + 'admin/subscriptions/templates/', template, {
            headers: { 'Authorization': `Bearer ${new Cookies().get('token')}` }
        }).then(response => {
            showToast('template_added');
            return response.data;
        }, () => {
            if (navigator.onLine) showToast('template_addition_failed');
            return;
        });
    }

    static checkVat(vat) {
        return Axios.get(BACKEND_ENDPOINT + 'users/vatInfos/?vat=' + vat, {
            headers: { 'Authorization': `Bearer ${new Cookies().get('token')}` }
        }).then(response => {
            const vatInformation = response?.data;
            if (vatInformation?.valid) {
                return {
                    customerName: vatInformation.name?.split(', ')?.reverse()?.join(' ') || '',
                    street: vatInformation.address?.split('\n')[0] || '',
                    postalCode: vatInformation.address?.split('\n')[1]?.split(' ')[0] || '',
                    city: vatInformation.address?.split('\n')[1]?.split(' ')?.slice(1)?.join(' ') || '',
                    countryCode: vatInformation.countryCode?.toLowerCase() || ''
                }
            } else return;
        }, () => {
            showToast('vat_validation_failed');
            return;
        });
    }

    static addSubscription(subscription) {
        return Axios.post(BACKEND_ENDPOINT + 'admin/subscriptions/', subscription, {
            headers: { 'Authorization': `Bearer ${new Cookies().get('token')}` }
        }).then(response => {
            showToast('subscription_added');
            return response.data;
        }, () => {
            showToast('subscription_addition_failed');
            return;
        });
    }

    static getUserSubscriptionConsumptions() {
        return Axios.get(BACKEND_ENDPOINT + 'subscriptions/userSubsriptionConsumptions/', {
            headers: { 'Authorization': `Bearer ${new Cookies().get('token')}` },
        }).then(response => {
            return response.data;
        }, () => {
            showToast('connection_failed');
            return;
        });
    }

    static activateSubscription(token) {
        const userToken = new Cookies().get('token');
        return Axios.get(BACKEND_ENDPOINT + 'subscriptions/activate/' + token, {
            headers: { 'Authorization': userToken && `Bearer ${userToken}` }
        }).then(response => {
            return response;
        }, () => {
            return;
        });
    }

    static exportQuotePDF(subscription, vat, recipient, observation) {
        return Axios.post(BACKEND_ENDPOINT + 'admin/subscriptions/exportQuotePDF', { subscription, vat, recipient, observation }, {
            responseType: 'arraybuffer',
            headers: {
                'Authorization': `Bearer ${new Cookies().get('token')}`,
                'Content-Type': 'application/json',
                'Accept': 'application/pdf'
            }
        }).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            const link = document.createElement('a');
            link.href = url;
            let filename = i18n.t("Devis");
            filename += '.pdf';
            link.setAttribute('download', filename);
            document.getElementById('tasksStatus').appendChild(link);
            link.click();
            document.getElementById('tasksStatus').removeChild(link);
            URL.revokeObjectURL(url);
        }, () => {
            return;
        });
    }
}